export default {
  state: {
    token: localStorage.getItem("user-token") || ""
  },
  getters: {},
  mutations: {
    FillToken(state, token) {
      state.token = token;
    }
  },
  actions: {
    authLogout: () => {
      localStorage.removeItem("user-token"); // clear your user's token from localstorage
    }
  }
};
